import React from 'react';
import Helmet from 'react-helmet';

const RedirectPage = (props) => {
  return (
    <Helmet>
      <meta
        http-equiv="refresh"
        content={`0;url=${props.pageContext.redirect}`}
      />
    </Helmet>
  );
};

export default RedirectPage;
